import { mapValues } from 'radash';
import { heights } from './heights.js';

/**
 * Collection of design tokens that define spacing values for gaps between elements.
 */ const gaps = mapValues(heights, (value)=>value / 4);

export { gaps };
//# sourceMappingURL=gaps.js.map
